import React, { useState } from "react";
import { Button, Col, Container, Image, Row, Card } from "react-bootstrap";
import { IMAGES } from "../../constants/images";
import ArrowIcon from "../../components/ArrowIcon";
import TestimonialSlider from "../../components/TestimonialSlider";
import { useLocation, useNavigate } from "react-router-dom";
import Modals from "inc/Modals";
import { useAuth } from "context/UserContext";
import { useUserRole } from "services/provider";
const highlights = [
  {
    icon: IMAGES.Value1_Img,
    title: "Real People, Real Reviews, 100% Verified",
    description:
      "Every reviewer is verified by multi-step processes to ensure only genuine product reviews surface.",
  },
  {
    icon: IMAGES.Value2_Img,
    title: "Ad-Free, Unbiased Reviews",
    description:
      "We maintain complete transparency by not selling paid placements. Every review and ranking is based on genuine user feedback.",
  },
  {
    icon: IMAGES.Value3_Img,
    title: "Prioritizing Excellence",
    description:
      "Each review is vetted for quality, depth, and detail by our Research Team before publishing.",
  },
];

const AboutUs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, user } = useAuth();
  const [modalType, setModalType] = useState("");
  const { role, setRole } = useUserRole();
  return (
    <React.Fragment>
      {/* Banner Section */}
      <section
        className="banner_section banner_section1"
        style={{ backgroundImage: `url(${IMAGES.Banner_Img})` }}
      >
        <Container>
          <Row>
            <Col md={12}>
              <h1>Manage & Master Your Reviews!</h1>
              <p className="mb-5">
                Xuthority is the trusted platform for managing and optimizing
                reviews. Businesses and professionals rely on it to track,
                respond to, and leverage customer feedback—powered by real,
                verified insights to build credibility and trust.
              </p>
              <Image src={IMAGES.Aboutsvg_Img} className="img-fluid" alt="" />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Categories Section */}
      <section
        className="py80 categories_section"
        style={{ backgroundImage: `url(${IMAGES.Gradient1_Img})` }}
      >
        <Container>
          <h2 className="text-center mb-5">Our Values</h2>
          <Row>
            <Col lg={12}>
              <Row className="mb-3">
                {highlights.map((item, index) => (
                  <Col key={index} md={4} lg={4} sm={4} className="mb-4">
                    <Card className="text-center valueCard">
                      <Image src={item.icon} alt="" />
                      <Card.Title className="fw-bold">{item.title}</Card.Title>
                      <Card.Text>{item.description}</Card.Text>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
            <div className="centerBtn text-center">
              <Button
                onClick={() => {
                  if (isLoggedIn) {
                    navigate("/write-a-review");
                    localStorage.removeItem("step");
                    localStorage.removeItem("checkedProducts");
                    localStorage.removeItem("verificationId");
                  } else {
                    setModalType("login");
                    setRole("user");
                  }
                }}
                className="border-radius-100 px-5"
                variant="info"
              >
                {(!user || user.role === "user")  ? (
                  <>Write a Review <ArrowIcon color="#ffffff" /></>
                ) : (
                  <>Join Us <ArrowIcon color="#ffffff" /></>
                )}
              </Button>
            </div>
          </Row>
        </Container>
      </section>
      {/* Review Section */}
      <section className="py80 review_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={6} className="mb-4 mb-lg-0 d-flex justify-content-center">
              <Image src={IMAGES.about_img} alt="Review" className="img-fluid" />
            </Col>
            <Col lg={6} md={6}>
              <h2>
                Achieve More. We’re
                <br />
                Here to Help
              </h2>
              <p>
                Xuthority is transforming the way businesses manage feedback
                by prioritizing real, user-driven insights. Instead of relying
                on biased ratings, we empower you with authentic customer
                experiences to build trust and make informed decisions. Your
                reputation, backed by real voices, helps you reach new heights.
              </p>
            {(!user || user.role === "user") && <Button
                onClick={() => {
                  navigate("/write-a-review");
                  localStorage.removeItem("step");
                  localStorage.removeItem("checkedProducts");
                  localStorage.removeItem("verificationId");
                }}
                className="border-radius-100"
                variant="info"
              >
                Write a Review <ArrowIcon color="#ffffff" />
              </Button>}
            </Col>
          </Row>
        </Container>
      </section>
      {/* Client Section */}
      <section className="py80 client_section position-relative">
        <Container className="position-relative z-1">
          <h2 className="text-center mb-5">What they Say About Us!</h2>
          <Row className="align-items-center">
            <Col lg={12} className="position-relative">
              <Image
                src={IMAGES.Clientsvg1_Img}
                alt="Review"
                className="img-fluid shapeImg1 z-0"
              />
              <TestimonialSlider />
            </Col>
          </Row>
        </Container>
        <Image
          src={IMAGES.Clientsvg2_Img}
          alt="Review"
          className="img-fluid shapeImg2 z-0"
        />
      </section>
      <Modals
        modalType={modalType}
        navigateTo={location.pathname || "/"}
        setModalType={setModalType}
        handleCloseModal={() => {
          setModalType("");
        }}
        {...{
          role: "user",
          navigate,
        }}
      />
    </React.Fragment>
  );
};
export default AboutUs;
